import type {
	PanelSwitcherTabAlign,
	PanelSwitcherTabVariant,
} from "../ui/types";

/**
 * Shared by the admin adapter (on load) and the public renderer (on render), so the two
 * cannot disagree about what a stored value means. Deliberately React-free and without a
 * `"use client"` directive — the adapter is imported by server code.
 */

const TAB_ALIGNS: readonly PanelSwitcherTabAlign[] = [
	"start",
	"center",
	"end",
	"stretch",
];

const TAB_VARIANTS: readonly PanelSwitcherTabVariant[] = [
	"separated",
	"joined",
	"underline",
];

// An unrecognised stored value falls back to the component default rather than reaching
// the DOM as a `data-align` nothing styles.
export function readPanelSwitcherTabAlign(
	raw: unknown
): PanelSwitcherTabAlign | undefined {
	return TAB_ALIGNS.find((v) => v === raw);
}

export function readPanelSwitcherTabVariant(
	raw: unknown
): PanelSwitcherTabVariant | undefined {
	return TAB_VARIANTS.find((v) => v === raw);
}
